module.exports = __webpack_public_path__ + "static/media/PDF-01.7a31a9a5.webp";